import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import "@circle-react-shared/BuilderUI/DefaultBlocks/utils/stylesHelpers";
import { secondaryBlockDefaultStyles } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/stylesHelpers";
import { useTopBlockStyles } from "@circle-react-shared/BuilderUI/Hooks/useTopBlockStyles";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export interface HomepageBlock4Props
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  button?: ReactNode;
  content?: ReactNode;
  header?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const HomepageBlock4 = forwardRef<HTMLDivElement, HomepageBlock4Props>(
  ({ header, content, button, className, styles, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: secondaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background
          className="wb-bg-secondary"
          style={backgroundStyles}
        >
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <BlockSection.NestedBlock className="wb-mx-auto wb-flex wb-flex-col wb-items-center wb-gap-4 wb-text-center md:wb-gap-6 wb-max-w-2xl">
                {header}
              </BlockSection.NestedBlock>
              <div className="wb-mx-auto wb-flex wb-flex-col wb-items-center wb-gap-4 md:wb-gap-14 wb-text-center">
                <div className="wb-bg-primary wb-flex wb-flex-col wb-gap-6 wb-rounded-3xl wb-px-6 wb-py-5 md:wb-gap-9 md:wb-px-9 md:wb-py-10">
                  <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-6">
                    {content}
                  </BlockSection.NestedBlock>
                </div>
                <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-3 md:wb-gap-5 wb-mx-auto">
                  {button}
                </BlockSection.NestedBlock>
              </div>
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

HomepageBlock4.displayName = "HomepageBlock4";
